export const ar = {
  roles: {
    rep: "مندوب",
    manager: "مدير",
    admin: "مدير عام",
    owner: "مالك",
  },
  triggers: {
    confirmation_needed: "تحتاج تأكيد",
    open_draft_orders: "طلبات مسودة مفتوحة",
    checkout_recovery: "استرداد السلة",
  },
  statuses: {
    open: "مفتوحة",
    snoozed: "مؤجلة",
    completed: "مكتملة",
    complete: "مكتملة",
  },
  priorities: {
    high: "عالية",
    medium: "متوسطة",
    low: "منخفضة",
  },
  userStatus: {
    active: "نشط",
    deactivated: "غير نشط",
    pending: "قيد الانتظار",
    deleted: "محذوف",
  },
  outcomes: {
    confirmed: "مؤكد",
    call_again: "الاتصال مرة أخرى",
    no_answer: "لا رد",
    wrong_phone: "هاتف خاطئ",
    do_not_call: "عدم الاتصال",
    customer_cancelled: "طلب العميل الإلغاء",
    needs_edit: "يحتاج تعديل",
    recovered: "مسترد",
    converted: "محول",
    cancelled: "ملغى",
    rescheduled: "تمت إعادة الجدولة",
    left_voicemail: "تم ترك رسالة صوتية",
    wrong_number: "رقم خاطئ",
    duplicate: "مكرر",
    not_applicable: "غير قابل للتطبيق",
    other: "أخرى",
  },
  notifications: {
    header: "الإشعارات",
    markAllRead: "تعليم الكل كمقروء",
    noNotifications: "لا توجد إشعارات",
    notificationSettings: "إعدادات الإشعارات",
    preferencesHeader: "تفضيلات الإشعارات",
    saveError: "فشل حفظ تفضيل الإشعارات.",
    prefToggles: {
      taskAssigned: {
        label: "تعيين مهمة",
        description: "إعلام عند تعيين مهمة لك",
      },
      taskUnassigned: {
        label: "إلغاء تعيين مهمة",
        description: "إعلام عند إزالة مهمة من قائمتك",
      },
      teamTaskAssigned: {
        label: "تعيين مهمة للفريق",
        description: "إعلام عند تعيين مهمة لعضو في الفريق",
      },
      snoozeExpired: {
        label: "انتهاء التأجيل",
        description: "إعلام عندما يكون المهمة المؤجل جاهزًا للمتابعة",
      },
    },
  },
} as const;
